import { CookieAlmeSessionDataLoader } from '@alme/session-ts/CookieAlmeSessionDataLoader';
import * as Loaders from '@alme/storage-ts/CookieLoader';
import { gettopdomain } from '../../utils/UrlUtils';
const storageLoader = new Loaders.CookieLoader('almeSession');
storageLoader.cookieOptions = { domain: gettopdomain() };
const cookieSessionLoader = new CookieAlmeSessionDataLoader(storageLoader);
const sessionDataLoader = cookieSessionLoader;
export function getAlmeSessionData() {
    let almeSessionData;
    try {
        almeSessionData = sessionDataLoader.GetAlmeSessionData();
    }
    catch (ex) {
        console.error(ex);
    }
    return almeSessionData;
}
